import { render, staticRenderFns } from "./ManagerContacts.vue?vue&type=template&id=19289784&scoped=true&"
import script from "./ManagerContacts.vue?vue&type=script&lang=js&"
export * from "./ManagerContacts.vue?vue&type=script&lang=js&"
import style0 from "./ManagerContacts.vue?vue&type=style&index=0&id=19289784&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19289784",
  null
  
)

export default component.exports